import { useApp } from '@/context/AppContext';

export default function MobileHome() {
  const { stats = {}, userEmail } = useApp();
  const name = userEmail ? userEmail.split('@')[0] : null;
  const activeJobs = stats.activeJobs ?? 0;
  return (
    <div style={{ padding: 16 }}>
      <div className="card" style={{ padding: 20 }}>
        <h2 style={{ marginTop: 0 }}>Welcome{name ? `, ${name}` : ''}</h2>
        <p style={{ color: 'var(--t3, #6b7280)' }}>
          {activeJobs} active job{activeJobs === 1 ? '' : 's'} · {stats.piecesInProgress ?? 0} pieces in progress
        </p>
      </div>
      <div style={{ marginTop: 16, color: 'var(--t3, #6b7280)', fontSize: 13 }}>
        Use the bottom nav to view jobs or open the clock-in screen.
      </div>
    </div>
  );
}
